module.exports = __webpack_public_path__ + "img/main_sub_card_coffee.8c65fa9a.png";